/* 張飛（字翼德） */
import { defineHero, S } from '../define.ts';

export default defineHero({
  id: 'zhangfei', name: '張飛', sub: '字翼德', faction: 'shu', role: '坦克', weapon: 'snake',
  look: { weaponName: '丈八蛇矛', skin: '#7a5238', beard: 'bushy', eye: 'fierce', head: 'hood', bulk: 1.12, fx: '#ff9a6a', c: { hood: '#26262c', armor: '#2f4a3a', sleeve: '#26262c', cloth: '#23382c', cape: '#26262c', pole: '#3a2a20' } },
  skills: [
    ['動地跺', 'roar', '猛擊地面，對周圍敵人造成 {75/100/125/150} 傷害並震暈 {1.5/2/2.5/3} 秒。', { x: { k: 'aoe', self: true, dmg: [75, 100, 125, 150], r: [200, 240, 280, 280], cc: { stun: [1.5, 2, 2.5, 3] }, ground: true, fx: 'slam' }, aim: S([200, 240, 280, 280]), cd: 15, mp: 100, el: 'earth' }],
    ['狂戰士', 'buff', '攻速 +{50/80/110/130}%、移速 +{10/15/20/25}%，但多受 20% 傷害，持續 12 秒。', { x: { k: 'buff', as: [50, 80, 110, 130], ms: [10, 15, 20, 25], taken: 20, dur: 12 }, cd: 35, mp: [70, 90, 110, 130] }],
    ['硬漢', 'passive', '生命低於 35% 時，防禦 +{7/11/15/19}。', { pv: { lowHp: { below: 35, armor: [7, 11, 15, 19] } } }],
    ['力量強化', 'passive', '強化肉體，力量 +{10/20/30}。', { pv: { str: [10, 20, 30] } }],
  ],
});
